import moment from "moment";

import schema from "./validate";
import api, { optimiseApi } from "../api";
import { stringifyQuery, DATE_FORMAT } from "../../utils/query";

export const getRoutes = async (depotId, sectionId, date, userId) => {
  const { data } = await api.get(
    `/depot/${depotId}/section/${sectionId || ""}/route?${stringifyQuery({
      date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
      userId,
    })}`
  );

  try {
    const result = await schema.validateAsync(data);

    return {
      routes: result.routes.sort((a, b) =>
        a.routeCode.localeCompare(b.routeCode)
      ),
      depotStats: result.depotStats,
    };
  } catch (error) {
    // eslint-disable-next-line
    console.warn("Invalid getRoutes data", error);
  }
};

export const getRoutesTransfer = async (depotId, date, userId) => {
  const { data } = await api.get(
    `/depot/${depotId}/route?${stringifyQuery({
      date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
      userId,
    })}`
  );
  return data;
};

export const getRouteDetail = async (depotCode, routeId) => {
  const { data } = await api.get(`/depot/${depotCode}/route/${routeId}`);

  return data;
};

export const unlockRoute = async (
  depotCode,
  userName,
  { routeId, checksum },
  forceUnlock
) =>
  api.post(`/depot/${depotCode}/route/unlock`, null, {
    userName,
    route: [{ routeId, checksum, forceUnlock }],
  });

export const setCutOffTime = async (
  depotCode,
  date,
  { waveCutOff, departTime }
) =>
  api.put(`/depot/${depotCode}/routes`, null, {
    waveCutOff,
    departTime,
    date: `${moment.utc(date, DATE_FORMAT).toDate().getTime()}`,
  });

export const lockRoute = async (
  depotCode,
  userName,
  { routeId, checksum },
  stops = []
) =>
  api.post(`/depot/${depotCode}/route/lock`, null, {
    userName,
    stops,
    route: [{ routeId, checksum }],
  });

export const changeRouteStatus = async (depotCode, routeStatus, routeId) =>
  api.post(`/depot/${depotCode}/route/${routeId}/status`, null, {
    routeStatus,
  });

export const scheduleRoute = async (depotCode, routeId, scheduleData) =>
  optimiseApi.post(
    `/depot/${depotCode}/route/${routeId}/schedule`,
    null,
    scheduleData
  );

export const saveRoute = async (depotCode, routeId, routeData) =>
  optimiseApi.put(`/depot/${depotCode}/route/${routeId}`, null, routeData);

export const createRoute = async (depotCode, route) =>
  optimiseApi.post(`/depot/${depotCode}/route/`, null, route);

export const validateRouteCode = async (depotCode, routeCode, date) => {
  const { data = {} } = await optimiseApi.get(
    `/depot/${depotCode}/route/${routeCode}/validate?${stringifyQuery({
      date: moment.utc(date, DATE_FORMAT).format("YYYY-MM-DD"),
    })}`
  );

  return data;
};
